import { Text, Paper, SimpleGrid, Skeleton } from "@mantine/core";

const WalletStats = ({ deposit, withdrawal, loading }) => {
  const statsData = [
    {
      label: "Total Deposit",
      amount: deposit,
      color: "#E8AC13",
      bg: "#FFF7DB",
    },
    {
      label: "Total Withdrawal",
      amount: withdrawal,
      color: "#00C864",
      bg: "#F1FFF8",
    },
  ];

  const stats = statsData.map((stat, index) => {
    return (
      <Skeleton visible={loading} key={index}>
        <Paper withBorder radius="md" shadow="xs" py="sm" px="sm" bg={stat.bg} h="100%">
          <Text c="#333" size="sm" fw={600} mb={4}>
            {stat.label}
          </Text>
          <Text c={stat.color} fw={700} size="xl" style={{ wordBreak: "break-word", lineHeight: 1.2 }}>
            ₹ {stat.amount}
          </Text>
        </Paper>
      </Skeleton>
    );
  });

  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
      {stats}
    </SimpleGrid>
  );
};

export default WalletStats;
